import axios from '../plugins/axios'
// const URL = 'http://localhost:5000';
//axios.defaults.headers.common['token'] = 'value' 
//call HID from localstorage

export default class hidServices {
   
  async simpanHID(data){
    
    try {
      
        const res = await axios.post(`${process.env.VUE_APP_API_URL}/HID/daftarHID`, {
        PUSINGAN: data.PUSINGAN,
        BULAN: data.BULAN,
        TAHUN: data.TAHUN,
        KAW: data.KAW,
        NG: data.NG,
        NEGERI: data.NEGERI,
        BNO: data.BNO,
        Nama: data.Nama,
        //NOIC : data.NOIC,
        Alamat: data.Alamat,
        Alamat1 : data.Alamat1,
        Alamat2 : data.Alamat2,
        Alamat3 : data.Alamat3,
        Poskod : data.Poskod,
        Notelefon : data.Notelefon,
        Email : data.Email,
        TK_ulangan: data.TK_ulangan,
        Sample : data.Sample,
        P: data.P,
        S : data.S,
        DP : data.DP,
        DB : data.DB,
        BP : data.BP,
        ST : data.ST,
        NOTK : data.NOTK,
        NOIR : data.NOIR,
        R : data.R,
        JIR: data.JIR,
        TOTJIR: data.TOTJIR,
        namaPOperasi: data.namaPOperasi,
        namaPProsesan: data.namaPProsesan,
        HID: data.HID,
        pengisian: data.pengisian
      })
        //console.log(result);
        return res;
      } catch (error) {
        //console.log(error)
        return error;  
    }
     
  }

  async updateHID(data){
    
    try {
      
        const res = await axios.post(`${process.env.VUE_APP_API_URL}/HID/updateHID`, {
        PUSINGAN: data.PUSINGAN,
        BULAN: data.BULAN,
        TAHUN: data.TAHUN,
        KAW: data.KAW,
        NG: data.NG,
        NEGERI: data.NEGERI,
        BNO: data.BNO,
        Nama: data.Nama,
        //NOIC : data.NOIC,
        Alamat: data.Alamat,
        Alamat1 : data.Alamat1,
        Alamat2 : data.Alamat2,
        Alamat3 : data.Alamat3,
        Poskod : data.Poskod,
        Notelefon : data.Notelefon,
        //Email : data.Email,
        TK_ulangan: data.TK_ulangan,
        Sample : data.Sample,
        P: data.P,
        S : data.S,
        DP : data.DP,
        DB : data.DB,
        BP : data.BP,
        ST : data.ST,
        NOTK : data.NOTK,
        NOIR : data.NOIR,
        R : data.R,
        JIR: data.JIR,
        TOTJIR: data.TOTJIR,
        namaPOperasi: data.namaPOperasi,
        namaPProsesan: data.namaPProsesan,
        HID: data.HID,
        toBeUpdatedHID: data.toBeUpdatedHID,
        pengisian: data.pengisian
      })
        //console.log(result);
        return res;
      } catch (error) {
        //console.log(error)
        return error;  
    }
     
  }


  async dpValidation(insertValuse){
    if(insertValuse == ''){
      return 'SALAH'
    }else{
    
      try {
        const res = await axios.get(URL+`/HID/checkDP?DP=`+insertValuse, {
        })
          //console.log(res.data.status)
          var stat = res.data.status;
          return stat;
          
        } catch (error) {
          console.log(error)
          //return error
      }
    }
   
  }

  async dbValidation(insertValuse){
    if(insertValuse == ''){
      return 'SALAH'
    }else{
    
      try {
        const res = await axios.get(URL+`/HID/checkDB?db=`+insertValuse, {
        })
          //console.log(res.data.status)
          var stat = res.data.status;
          return stat;
          
        } catch (error) {
          console.log(error)
          //return error
      }
    }
   
  }

  async bpValidation(insertValuse){
    if(insertValuse == ''){
      return 'SALAH'
    }else{
    
      try {
        const res = await axios.get(URL+`/HID/checkBP?bp=`+insertValuse, {
        })
          //console.log(res.data.status)
          var stat = res.data.status;
          return stat;
          
        } catch (error) {
          console.log(error)
          //return error
      }
    }
   
  }

  async stValidation(insertValuse){
    if(insertValuse == ''){
      return 'SALAH'
    }else{
    
      try {
        const res = await axios.get(URL+`/HID/checkST?st=`+insertValuse, {
        })
          //console.log(res.data.status)
          var stat = res.data.status;
          return stat;
          
        } catch (error) {
          console.log(error)
          //return error
      }
    }
   
  }

}